import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  AUTH,
  LoginInterface,
  LoginOTPInterface,
  LoginOTPResponseInterface,
  LoginResponseInterface,
  VendorDataInterface,
  VendorInterface,
  VENDOR_STATUS,
} from '../types/login.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  currentUser = signal<VendorDataInterface | undefined | null>(undefined);
  status = signal<boolean>(null);
  authError = signal<string | undefined | null>(undefined);
  isLoggedIn = signal<boolean>(false);
  isLoading = signal<boolean>(false);

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  login(data: LoginInterface): Observable<LoginResponseInterface> {
    const url = environment.apiUrl + '/auth/login';
    return this.http.post<LoginResponseInterface>(url, data);
  }

  submitOTP(data: LoginOTPInterface) {
    this.isLoading.set(true);
    const url = environment.apiUrl + '/auth/submit_otp';
    this.http.post<LoginOTPResponseInterface>(url, data).subscribe({
      complete: () => {
        this.router.navigateByUrl('/dashboard');
      },
      next: res => {
        if (res.token) {
          sessionStorage.setItem(AUTH.TOKEN, res.token);
          this.isLoggedIn.set(true);
          this.getVendorData();
        }
        this.isLoading.set(false);
      },
      error: () => {
        this.authError.set('Login Error');
        this.isLoggedIn.set(true);
        this.isLoading.set(false);
      },
    });
  }

  getVendorData(): void {
    const url = environment.apiUrl + '/vendor/vendor_data';
    this.http.get<VendorInterface>(url).subscribe(res => {
      //revert after backend fix
      const taxRegTemp = res.d.TaxRegNo;
      res.d.TaxRegNo = res.d.TaxNum;
      res.d.TaxNum = taxRegTemp;
      this.currentUser.set(res.d);
      this.status.set(res.d?.Status === VENDOR_STATUS.APPROVED);
      this.isLoggedIn.set(true);
    });
  }

  isAuthenticated(): boolean {
    if (this.currentUser()) {
      return true;
    } else {
      return false;
    }
  }

  forgetPassword(data: { TaxRegNo: string }): Observable<unknown> {
    const url = environment.apiUrl + '/auth/psw_reset_req';
    return this.http.post<Observable<unknown>>(url, data);
  }

  resetPassword(data: {
    Token: string;
    Password: string;
  }): Observable<unknown> {
    const url = environment.apiUrl + '/auth/psw_reset';
    return this.http.post<Observable<unknown>>(url, data);
  }

  logout() {
    sessionStorage.removeItem(AUTH.TOKEN);
    this.isLoggedIn.set(false);
    this.currentUser.set(undefined);
    window.location.href = '/';
  }
}
